import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { updateRoleName } from '../../../../reducers/roles.reducer';
import { Role } from '../../../../models/user.model';
import Modal from '../../../atoms/modal/modal';
import Button from '../../../atoms/button/button';
import { closeModal } from '../../../../reducers/modal.reducer';
import { Form, FormError, FormItem, FormRow } from 'src/components/atoms/form';
import Label from 'src/components/atoms/label/label';
import Spinner from '../../../atoms/spinner/spinner';
import { validationSchema } from '../../../../utils/validation-utils';

type Props = {
  role: Role;
};

export const EditRoleNameModal = (props: Props) => {
  const { role } = props;
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(state => state.roles);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { newName: role.name ?? '' },
  });

  const onSubmit = (data: { newName: string }) => {
    dispatch(updateRoleName({ roleId: role.id, newName: data.newName }));
  };

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <Form>
          <FormRow>
            <FormItem>
              <Label>Nome</Label>
              <input
                type="text"
                placeholder="Inserisci il nome del ruolo"
                autoComplete="off"
                className={`form-control ${errors.newName ? 'is-invalid' : ''}`}
                {...register('newName', validationSchema.required)}
              />
              <FormError error={errors?.newName} validation={validationSchema.required} />
            </FormItem>
          </FormRow>
          <FormRow col="2">
            <FormItem>
              <Button onClick={() => dispatch(closeModal())} size="sm" rounded="rounded-sm" color="light-grey" mode="outline" fullWidth>
                Annulla
              </Button>
            </FormItem>
            <FormItem>
              <Button
                type="submit"
                size="sm"
                rounded="rounded-sm"
                color="black"
                mode="solid"
                fullWidth
                disabled={!isValid || loading}
                onClick={handleSubmit(onSubmit)}
              >
                {loading ? <Spinner color="white" /> : 'Salva'}
              </Button>
            </FormItem>
          </FormRow>
        </Form>
      </Modal.Body>
    </>
  );
};
